<template>
	<div class="ztbox">
		<!--<div class="ztheader">
	</div>-->
		<div class="ztcenter">
			<div class="centerone">
				品牌数据
			</div>
			<div class="centertwo flex spa-bet">
				<div class="twoleft">
					<div class="leftbox">
						<p class="lefttext1"><span class="leftspan">{{ sjdata2.totalNum }}</span>个</p>
						<p class="lefttext">总数量</p>
					</div>
					<img src="@/assets/images/xin/t11.png" class="leftimg" alt="" />
					<div class="leftbox">
						<p class="lefttext1"><span class="leftspan">{{ sjdata2.BK }}</span>所</p>
						<p class="lefttext">职业本科</p>
					</div>
					<img src="@/assets/images/xin/t11.png" class="leftimg" alt="" />
					<div class="leftbox">
						<p class="lefttext1"><span class="leftspan">{{ sjdata2.ZZ }}</span>所</p>
						<p class="lefttext">中职院校</p>
					</div>
					<img src="@/assets/images/xin/t11.png" class="leftimg" alt="" />
					<div class="leftbox">
						<p class="lefttext1"><span class="leftspan">{{ sjdata2.GZ }}</span>所</p>
						<p class="lefttext">高职院校</p>
					</div>
					<img src="@/assets/images/xin/t11.png" class="leftimg" alt="" />
					<div class="leftbox">
						<p class="lefttext1"><span class="leftspan">{{ sjdata2.JG }}</span>所</p>
						<p class="lefttext">技工院校</p>
					</div>
				</div>
				<div class="tworight">
					<div class="rightitem">
						<img src="@/assets/images/xin/t3.png" class="rightimg" alt="" />
						<p class="righttext">职业本科</p>
						<div class="rightlist">
							<p class="listtext">品牌数量：<span class="listspan">{{ sjdata3.BK.tatal }}个</span></p>
							<p class="listtext">品牌占比：<span class="listspan">{{ sjdata3.BK.rate }}%</span></p>
							<p class="listtext">学校品牌平均数：<span class="listspan">{{ sjdata3.BK.avgSchool }}</span></p>
						</div>
					</div>
					<div class="rightitem">
						<img src="@/assets/images/xin/t4.png" class="rightimg" alt="" />
						<p class="righttext">高职院校</p>
						<div class="rightlist">
							<p class="listtext">品牌数量：<span class="listspan">{{ sjdata3.GZ.tatal }}个</span></p>
							<p class="listtext">品牌占比：<span class="listspan">{{ sjdata3.GZ.rate }}%</span></p>
							<p class="listtext">学校品牌平均数：<span class="listspan">{{ sjdata3.GZ.avgSchool }}</span></p>
						</div>
					</div>
					<div class="rightitem">
						<img src="@/assets/images/xin/t5.png" class="rightimg" alt="" />
						<p class="righttext">中职院校</p>
						<div class="rightlist">
							<p class="listtext">品牌数量：<span class="listspan">{{ sjdata3.ZZ.tatal }}个</span></p>
							<p class="listtext">品牌占比：<span class="listspan">{{ sjdata3.ZZ.rate }}%</span></p>
							<p class="listtext">学校品牌平均数：<span class="listspan">{{ sjdata3.ZZ.avgSchool }}</span></p>
						</div>
					</div>
					<div class="rightitem">
						<img src="@/assets/images/xin/t6.png" class="rightimg" alt="" />
						<p class="righttext">技工院校</p>
						<div class="rightlist">
							<p class="listtext">品牌数量：<span class="listspan">{{ sjdata3.JG.tatal }}个</span></p>
							<p class="listtext">品牌占比：<span class="listspan">{{ sjdata3.JG.rate }}%</span></p>
							<p class="listtext">学校品牌平均数：<span class="listspan">{{ sjdata3.JG.avgSchool }}</span></p>
						</div>
					</div>
				</div>
			</div>

			<div class="centerthree">
				<div class="threelist flex spa-bet">
					<div class="listitem">
						<div class="listtitle">
							各城市品牌分布
						</div>
						<div class="listbg" id="ppfb">

						</div>
					</div>
					<!-- <div class="listitem">
						<div class="listtitle">
							品牌归属
							<a-select v-model="schoolTypes"
								style="width: 100px; margin-left:10px;margin-top:7px;position: absolute;right:10px;"
								@change="handleChange2" :dropdownClassName="'customClass'">
								<a-select-option value="GZ">高职院校</a-select-option>
								<a-select-option value="ZZ">中职院校</a-select-option>
								<a-select-option value="BK">职业本科</a-select-option>
								<a-select-option value="JG">技工院校</a-select-option>
							</a-select>
						</div>
						<div class="listbg">
							<div class="listone">共建设了<span class="listonespan">{{ sj.majorNum }}</span>个专业，覆盖了省专业的<span
									class="listonespan">{{ sj.majorRate }}</span>%</div>
							<div style="width:100%;height:274px;" id="bt"></div>
						</div>
					</div> -->
					<div class="listitem">
						<div class="listtitle">
							品牌归属
						</div>
						<div class="listbg">
							<!-- <div class="listone">共建设了<span class="listonespan">XX</span>个专业，覆盖了省专业的<span class="listonespan">XX</span>%</div> -->
							<div style="width:100%;height:274px;" id="bt"></div>
						</div>
					</div>
					<div class="listitem">
						<div class="listtitle">
							品牌文化
						</div>
						<div class="listbg" id="bq">

						</div>
					</div>
					<!-- <div class="listitem">
						<div class="listtitle">
							资金预算
							<div class="titletext">
								预算金额：
								<span class="titlespan">{{ sjdata.预算金额 }}元</span>
							</div>
						</div>
						<div class="listbg" id="bt2">

						</div>
					</div>
					<div class="listitem">
						<div class="listtitle">
							资金使用
							<div class="titletext">
								实际资金使用：
								<span class="titlespan">{{ sjdata1.total }}万元</span>
							</div>
						</div>
						<div class="listbg">
							<div class="bglist">
								<div class="bgitem" v-for="(item, index) in sjdata1.dataList" :key="index">
									<span class="bgi1">{{ item.name }}资金使用率</span>
									<span class="bgi2">{{ item.value }}%</span>
								</div>
								
							</div>
							<div style="width:100%; height:218px;" id="zztd">
							</div>
						</div>
					</div> -->
					<div class="listitem ">
						<div class="listtitle">
							教师职称分布
							<!-- 特色文化育人品牌成果 -->
						</div>
						<div class="listbg">
							<div style="width:100%;height:220px" id="bt13"></div>
							<div class="btlist">
	     					  <div class="btitem" :class="`btitem${index}`" v-for="(item,index) in jslist" :key="index">
	     						<span class="btitemspan">{{item.name}}</span>
	     						<span class="btitemspan1" >{{item.value}}人</span>
	     						<span class="btitemspan1" >{{item.rate}}%</span>
	     					</div>
	     				</div>
						</div>
					</div>
				</div>
				<div class="threelist flex spa-bet">
					<div class="listitem ">
						<div class="listtitle">
							<!-- 教师职称分布 -->
							特色文化育人品牌成果
						</div>
						<div class="listbg">
							<div style="width:100%;height:300px" id="bt3"></div>
							<!-- <div class="btlist">
	     					<div class="btitem" :class="`btitem${index}`" v-for="(item,index) in jslist" :key="index">
	     						<span class="btitemspan">{{item.name}}</span>
	     						<span class="btitemspan1" >{{item.value}}人</span>
	     						<span class="btitemspan1" >{{item.rate}}%</span>
	     					</div>
	     				
	     				
	     				</div> -->
						</div>
					</div>
					<div class="listitem">
						<div class="listtitle">
							品牌内涵
						</div>
						<div class="listbg" ref="wordChart">

						</div>
					</div>
					<div class="listitem">
						<div class="listtitle">
							品牌教学成果
						</div>
						<div class="listbg" id="mgt">

						</div>
					</div>
					<div class="listitem">
						<div class="listtitle">
							<span style="display: inline-block;width:40%;overflow: hidden;"
								title="特色文化育人品牌信息">特色文化育人品牌信息</span>
							<a-select v-model="year" style="width: 100px; margin-left: 10px;margin-top:7px;"
								@change="handleChange" :dropdownClassName="'customClass'">
								<a-select-option value="2024">2024</a-select-option>
								<a-select-option value="2023">2023</a-select-option>
								<a-select-option value="2022">2022</a-select-option>
								<a-select-option value="2021">2021</a-select-option>
							</a-select>
							<a-select v-model="schoolType" style="width: 100px; margin-left:10px;margin-top:7px;"
								@change="handleChange1" :dropdownClassName="'customClass'">
								<a-select-option value="GZ">高职院校</a-select-option>
								<a-select-option value="ZZ">中职院校</a-select-option>
								<a-select-option value="BK">职业本科</a-select-option>
								<a-select-option value="JG">技工院校</a-select-option>
							</a-select>
						</div>
						<div class="listbg">
							<div style="
					            display: flex;
					            flex: 1;
					            overflow: hidden;
					            flex-direction: column;
					          ">
								<table class="tables">
									<colgroup>
										<col width="50%" />
										<col width="50%" />
										<col width="8px" />
									</colgroup>
									<thead>
										<tr>
											<th>品牌名称</th>
											<th>学校名称</th>
										</tr>
									</thead>
								</table>

								<div style="width:100%;overflow: hidden;height:330px;overflow-y: auto;">
									<table class="tables">
										<colgroup>
											<col width="50%" />
											<col width="50%" />
										</colgroup>
										<tbody>
											<tr v-for="(item, index) in cglist" :key="index">
												<td>{{ item.name }}</td>
												<td>{{ item.realname }} </td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<modal-component :show="showModal" :id="modalId" :title="title"  @close="showModal = false"></modal-component>

	</div>
</template>

<script>
import * as echarts from 'echarts';
import HighCharts from "highcharts";
import { getAction, postAction, putAction, deleteAction } from "@/api/index";
import 'echarts-wordcloud';
import  modalComponent from "./modalComponent.vue";
export default {
	data() {
		return {
			sjdata: {},
			sjdata1: {},
			sjdata2: {},
			sjdata3: {
				BK: {
					tatal: '',
					rate: '',
					avgSchool: '',
				},
				GZ: {
					tatal: '',
					rate: '',
					avgSchool: '',
				},
				ZZ: {
					tatal: '',
					rate: '',
					avgSchool: '',
				},
				JG: {
					tatal: '',
					rate: '',
					avgSchool: '',
				}
			},
			year: '2021',
			schoolType: 'GZ',
			cglist: [],
			jslist: [],
			schoolTypes: 'GZ',
			sj: {},
			showModal:false,
			title:'',
			modalId:'',
		}
	},
	components:{
		modalComponent
	},
	mounted() {
		//		if(window.innerWidth>1440){
		//			this.mgt(['30%', '70%']);
		//			this.getppfb('4%');
					// this.getMyChart5('180');
		//			this.brandTagAct('bq',['37%','48%'],['57%','68%'],20,['0','30%'],16);
		//		}else{
		//			this.mgt(['20%', '50%']);
		//			this.getppfb('10%');
					// this.getMyChart5('140');
		//			this.brandTagAct('bq',['27%','38%'],['47%','55%'],10,['0','20%'],14);
		//		}


		//		let VALUE6 = ['太原', '大同','阳泉','长治','晋城','朔州','晋中','运城','忻州','临汾','吕梁'];
		//		let VALUE11 = [100,100,80,100,100, 100,100,100,100, 100,100];
		//		this.zzt2dd("zztd", VALUE6,VALUE11);
		this.getcglist();
		this.getfindUse();
		this.getBudget();
		this.getfoundSit();
		this.getProfes();
		this.getpp();
		this.getBaseNum();
		this.getyrBase();
		this.getType();
		this.getCategory();
		this.getlabel();
		// this.getmgt();
		this.getWordChart()
		this.getszjd('mgt')
	},
	methods: {
		getpp(){
			getAction('/analysis/brandAchievements', {
				applyType: '2',
			}).then((res) => {
				if (res.code == '200') {
					let arr = [];
					console.log(res,"4444");
					let sj = res.result.headList;
					// console.log(sj,"4444");
					for (var i = 0; i < sj.length; i++) {
						let arr1 = [];
						arr1.push(sj[i]);
						arr1.push(res.result.dataList[i]);
						arr.push(arr1);
					}
					this.getMyChart3(arr);
				}
			});
		},
		getWordChart() {
			getAction('/analysis/brandConnotation', {
				applyType: '3',
			}).then((res) => {
				if (res.code == '200') {
					// let result=res.result.dataList;
					const result = res.result.dataList.map(item => ({
							name: item,
							value: (Math.random() * 3 + 13).toFixed(2) // 生成13-16之间的随机数，保留2位小数
					}));
					const chart = echarts.init(this.$refs.wordChart);
					chart.setOption({
						series: [{
							type: 'wordCloud',
							data:result,
							//  [
							// 	{ 'name': '胸怀理想', 'value': 13 },
							// 	{ 'name': '建功立业', 'value': 14 },
							// 	{ 'name': '民族自信', 'value': 16 },
							// 	{ 'name': '顽强拼搏', 'value': 15 },
							// 	{ 'name': '文化自信', 'value': 12 },
							// 	{ 'name': '奋发图强', 'value': 13 },
							// 	{ 'name': '刚健有为', 'value': 14 },
							// ],
							sizeRange: [16, 30],
							textStyle: { color: () => this.randomColor(), fontSize: '18-50' }
						}]
					});
					// this.gethh(res.result.cityList, res.result.dataList, res.result.rateList, res.result.schoolTypeList);
				}
			});
			// const chart = echarts.init(this.$refs.wordChart);
			// chart.setOption({
			// 	series: [{
			// 		type: 'wordCloud',
			// 			data: [
			// 			{ 'name': '爱国主义', 'value': 13 },
			// 			{ 'name': '理想信念', 'value': 14 },
			// 			{ 'name': '责任担当', 'value': 16 },
			// 			{ 'name': '大国工匠', 'value': 15 },
			// 			{ 'name': '劳模精神', 'value': 12 },
			// 			{ 'name': '劳动精神', 'value': 13 },
			// 			{ 'name': '法治规范', 'value': 15 },
			// 			{ 'name': '社会主义核心价值观', 'value': 15 },
			// 			{ 'name': '道德修养', 'value': 17 },],
			// 		sizeRange: [16, 30],
			// 		textStyle: { color: () => this.randomColor(),fontSize: '18-50'}
			// 	}]
			// });
		},
		randomColor() {
			const h = Math.floor(Math.random() * 360);
			const s = 80 + Math.floor(Math.random() * 20);
			const l = 60 + Math.floor(Math.random() * 30);

			// HSL转RGB再转HEX
			const a = s * Math.min(l, 100 - l) / 100;
			const f = n => {
				const k = (n + h / 30) % 12;
				const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
				return Math.round(255 * color / 100).toString(16).padStart(2, '0');
			};
			return `#${f(0)}${f(8)}${f(4)}`;
		},
		getmgt() {
			getAction('/analysis/brandLabel', {
				applyType: '2',
				sort: '1',
			}).then((res) => {
				let VALUE6 = [], VALUE11 = [];
				for (var i = 0; i < res.result.length; i++) {
					VALUE6.push(res.result[i].name);
					VALUE11.push(res.result[i].value);
				}
				if (window.innerWidth > 1440) {
					this.mgt(['30%', '70%'], VALUE6, VALUE11);
				} else {
					this.mgt(['20%', '50%'], VALUE6, VALUE11);
				}
			});
		},
		getlabel() {
			getAction('/analysis/brandLabel', {
				applyType: '2',
				sort: '0',
			}).then((res) => {
				//					console.log(
				if (res.code == '200') {
					let list = [{
						label: {
							textStyle: {
								color: "#106bff",
								fontSize: 18,
								fontWeight: 600,
								borderColor: "#517FD9",
							},
						}
					}, {
						label: {
							textStyle: {
								color: "#00b8ff",
								fontSize: 18,
								fontWeight: 600,
								borderColor: "#517FD9",
							},
						}
					}, {
						label: {
							textStyle: {
								color: "#ff6262",
								fontSize: 18,
								fontWeight: 600,
								borderColor: "#517FD9",
							},
						}
					}, {
						label: {
							textStyle: {
								color: "#ffb81a",
								fontSize: 18,
								fontWeight: 600,
								borderColor: "#517FD9",
							},
						}
					}, {
						label: {
							textStyle: {
								color: "#6fef33",
								fontSize: 18,
								fontWeight: 600,
								borderColor: "#517FD9",
							},
						}
					}, {
						label: {
							textStyle: {
								color: "#6faf33",
								fontSize: 18,
								fontWeight: 600,
								borderColor: "#517FD9",
							},
						}
					}];
					let list1 = [
						{
							itemStyle: { color: 'rgba(16,108,255,0.3)' }
						},
						{
							itemStyle: { color: 'rgba(0,184,255,0.3)' }
						},
						{
							itemStyle: { color: 'rgba(255,98,98,0.3)' }
						},
						{
							itemStyle: { color: 'rgba(255,184,26,0.3)' }
						},
						{
							itemStyle: { color: 'rgba(111,239,51,0.3)' }
						},
						{
							itemStyle: { color: 'rgba(111,249,51,0.3)' }
						},
					];
					let sj = res.result;
					let arr = [], arr1 = [];
					for (var i = 0; i < sj.length; i++) {
						//					      	console.log(list[i].label);
						arr.push({ name: sj[i].name, value: sj[i].value, label: list[i].label });
						arr1.push({ name: sj[i].name, value: sj[i].value, });
					}
					if (window.innerWidth > 1440) {
						this.brandTagAct('bq', ['37%', '48%'], ['57%', '68%'], 20, ['0', '30%'], 16, arr, arr1,sj);
					} else {
						this.brandTagAct('bq', ['27%', '38%'], ['47%', '55%'], 10, ['0', '20%'], 14, arr, arr1,sj);
					}
				}
			});
		},
		getCategory() {
			getAction('/analysis/schoolTypeMajorCategory', {
				applyType: '2',
				schoolType: this.schoolTypes,
			}).then((res) => {
				//					console.log(res,"11111");
				let arr = [];
				let sj = res.result.dataList;
				for (var i = 0; i < sj.length; i++) {
					let arr1 = [];
					arr1.push(sj[i].name);
					arr1.push(sj[i].value);
					arr.push(arr1);
				}
				this.sj = res.result;
				if (window.innerWidth > 1440) {
					this.getMyChart5('170', arr);
				} else {
					this.getMyChart5('140', arr);
				}
			});
		},
		handleChange2() {
			this.getCategory();
		},
		getType() {
			getAction('/analysis/citySchoolType', {
				applyType: '2',
			}).then((res) => {
				//					console.log(res);
				if (window.innerWidth > 1440) {
					this.getppfb('4%', res.result.cityList, res.result.dataList, res.result.schoolTypeList);
				} else {
					this.getppfb('10%', res.result.cityList, res.result.dataList, res.result.schoolTypeList);
				}
			});
		},
		getyrBase() {
			getAction('/analysis/yrBase', {
				applyType: '2',
			}).then((res) => {
				//					console.log(res);
				if (res.code == '200') {
					this.sjdata3 = res.result;
				}
			});
		},
		getBaseNum() {
			getAction('/analysis/yrBaseNum', {
				applyType: '2',
			}).then((res) => {
				//					console.log(res);
				if (res.code == '200') {
					this.sjdata2 = res.result;
				}
			});

		},
		getProfes() {
			getAction('/analysis/groupProfession', {
				applyType: '2',
			}).then((res) => {
				//					console.log(res,"11111");
				if (res.code == '200') {
					this.jslist = res.result;
					let arr = [];
					let sj = res.result;
					for (var i = 0; i < sj.length; i++) {
						let arr1 = [];
						arr1.push(sj[i].name);
						arr1.push(sj[i].value);
						arr.push(arr1);
					}
					// this.getMyChart3(arr);
					//						console.log();
					this.getMyChart3s(arr);
				}
			});
		},
		getcglist() {
			getAction('/analysis/applyView', {
				applyType: '2',
				year: this.year,
				schoolType: this.schoolType,
			}).then((res) => {
				//					console.log(res);
				if (res.code == '200') {
					this.cglist = res.result;
				}
			});
		},
		getfoundSit() {
			getAction('/analysis/fundSituation', {
				applyType: '2'
			}).then((res) => {
				//					console.log(res,"222222");
				if (res.code == '200') {
					//						let VALUE6 = ['太原', '大同', '阳泉', '长治', '晋城', '朔州', '晋中', '运城', '忻州', '临汾', '吕梁'];
					//						let VALUE11 = [10.92, 8.82, 8.4, 9.45, 8.82, 9.03, 9.03, 8.61, 9.24, 7.98, 9.66];
					let VALUE6 = [], VALUE11 = [];
					for (var i = 0; i < res.result.length; i++) {
						VALUE6.push(res.result[i].name);
						VALUE11.push(res.result[i].value);
					}
					this.zzt2dd("zztd", VALUE6, VALUE11);
				}

			});
		},
		getfindUse() {
			getAction('/analysis/fundUse', {
				applyType: '2'
			}).then((res) => {
				//					console.log(res,"1111");
				if (res.code == '200') {
					this.sjdata1 = res.result;
				}
			});
		},
		getBudget() {
			getAction('/analysis/capitalBudget', {
				applyType: '2'
			}).then((res) => {
				if (res.code == '200') {
					this.sjdata = res.result.data;
					let arr = [], arr2 = [];
					let sj = res.result.dataList;
					for (var i = 0; i < sj.length; i++) {
						let arr1 = [];
						arr1.push(sj[i].name);
						arr1.push(sj[i].rate);
						arr2.push(sj[i].totalAmount);
						arr.push(arr1);
					}
					// if (window.innerWidth > 1440) {
					// 	this.getMyChart6('240', arr, arr2);
					// } else {
					// 	this.getMyChart6('140', arr, arr2);
					// }
				}
			});
		},
		handleChange() {
			this.getcglist();
		},
		handleChange1() {
			this.getcglist();
		},
		brandTagAct(id, arr, arr1, value, value1, value2, list, list1,sj) {
			var myChart = echarts.init(document.getElementById(id));
			//	      let list = [
			//	        {
			//	          name: "非遗文化",
			//	          value: 10,
			//	          label: {
			//	            textStyle: {
			//	              color: "#106bff",
			//	              fontSize: 18,
			//	              fontWeight: 600,
			//	              borderColor: "#517FD9",
			//	            },
			//	          },
			//	        },
			//	        {
			//	          name: "革命文化",
			//	          value: 12,
			//	          label: {
			//	            textStyle: {
			//	              color: "#00b8ff",
			//	              fontSize: 18,
			//	              fontWeight: 600,
			//	              borderColor: "#517FD9",
			//	            },
			//	          },
			//	        },
			//	        {
			//	          name: "红色文化",
			//	          value: 33,
			//	          label: {
			//	            textStyle: {
			//	              color: "#ff6262",
			//	              fontSize: 18,
			//	              fontWeight: 600,
			//	              borderColor: "#517FD9",
			//	            },
			//	          },
			//	        },
			//	        {
			//	          name: "传统文化",
			//	          value: 42,
			//	          label: {
			//	            textStyle: {
			//	              color: "#ffb81a",
			//	              fontSize: 18,
			//	              fontWeight: 600,
			//	              borderColor: "#517FD9",
			//	            },
			//	          },
			//	        },
			//	        {
			//	          name: "其他",
			//	          value: 3,
			//	          label: {
			//	            textStyle: {
			//	              color: "#6fef33",
			//	              fontSize: 18,
			//	              fontWeight: 600,
			//	              borderColor: "#517FD9",
			//	            },
			//	          },
			//	        },
			//	      ];
			//
			//	      let list1 = [
			//	        {
			//	          name: "非遗文化",
			//	          value: 10,
			//	          itemStyle: { color: 'rgba(16,108,255,0.3)' } 
			//	        },
			//	        {
			//	          name: "革命文化",
			//	          value: 12,
			//	          itemStyle: { color: 'rgba(0,184,255,0.3)' } 
			//	        },
			//	        {
			//	          name: "红色文化",
			//	          value: 33,
			//	          itemStyle: { color: 'rgba(255,98,98,0.3)' } 
			//	        },
			//	        {
			//	          name: "传统文化",
			//	          value: 42,
			//	          itemStyle: { color: 'rgba(255,184,26,0.3)' } 
			//	        },
			//	        {
			//	          name: "其他",
			//	          value: 3,
			//	          itemStyle: { color: 'rgba(111,239,51,0.3)'} 
			//	        },
			//	      ];
			let angle = 0;
			let option = {
				color: [
					"#106bff",
					"#00b8ff",
					"#ff6262",
					"#ffb81a",
					"#6fef33",
					"#106bff",
					"#8d4bbb",
					"#6635EF",
					"#FFAFDA",
				],
				tooltip: {
					show: false,
				},
				legend: {
					show: false,
				},
				series: [
					//        {
					//          name: "访问来源",
					//          type: "pie",
					//          selectedMode: "single",
					//          center: ['50%', '50%'], 
					//          radius: arr,
					//          label: {
					//            normal: {
					//              show: false,
					//              position: "inner",
					//              formatter: "{d}%",
					//              textStyle: {
					//                color: "#fff",
					//                fontWeight: "normal",
					//                fontSize: 20,
					//              },
					//            },
					//          },
					//          labelLine: {
					//            normal: {
					//              show: false,
					//            },
					//          },
					//          itemStyle: {
					//            normal: {
					//              borderColor: "#001553",
					//              borderWidth: 0,
					//              color: "rgba(16,108,255,0.1)",
					//            },
					//          },
					//          data: list1,
					//        },
					{
						itemStyle: {
							normal: {
								borderColor: "#001553",
								borderWidth: 4,
							},
						},
						name: "访问来源",
						type: "pie",
						center: ['50%', '50%'],
						radius: arr1,
						label: {
							normal: {
								formatter: "{b|{d}%}\n{hr|}\n{d|{b}}",
								rich: {
									b: {
										fontSize: value2,
										align: "left",
										padding: 4,
									},
									hr: {
										borderColor: "#12EABE",
										width: "100%",
										borderWidth: 2,
										height: 0,
									},
									d: {
										fontSize: value2,
										color: "#fff",
										align: "left",
										padding: 4,
									},
									c: {
										fontSize: value2,
										color: "#fff",
										align: "center",
										padding: 4,
									},
								},
							},
						},
						labelLine: {
							normal: {
								show: true,
								length: value,
								length2: value,
								lineStyle: {
									type: "dashed",
									width: 2,
								},
							},
						},
						data: list,
					},
					{
						name: "ring5",
						type: "custom",
						hoverAnimation: false,
						clockwise: true,
						coordinateSystem: "none",
						z: 20, // 设置 markPoint 的 z-index
						zlevel: 2, // 设置 markPoint 的 zlevel
						renderItem: function (params, api) {
							return {
								type: "arc",
								shape: {
									cx: api.getWidth() / 2,
									cy: api.getHeight() / 2,
									r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.25,
									startAngle: ((270 + -angle) * Math.PI) / 180,
									endAngle: ((40 + -angle) * Math.PI) / 180,
								},
								style: {
									shadowColor: "#4FADFD",
									shadowBlur: 10,
									stroke: "#0CD3DB",
									fill: "transparent",
									lineWidth: 1.5,
								},
								silent: true,
							};
						},
						data: [0],
					},
					{
						name: "访问来源",
						type: "pie",
						clockwise: true,
						hoverAnimation: false,
						coordinateSystem: "none",
						radius: value1,
						center: ['50%', '50%'],
						data: [100],
						itemStyle: {
							normal: {
								color: "#043173",
							},
						},
						label: {
							show: false,
						},
						labelLine: {
							normal: {
								show: false,
								length: value,
								length2: value,
								lineStyle: {
									type: "dashed",
									width: 2,
								},
							},
						},
					},
				],
			};
			//    function draw() {
			//      angle = angle + 3;
			//      myChart.setOption(option, true);
			//      //window.requestAnimationFrame(draw);
			//    }
			//
			//    myChart.on("finished", function () {
			//      setInterval(function () {
			//        //用setInterval做动画感觉有问题
			//        draw();
			//      }, 100);
			//      // 在这里执行你想要在渲染完成后执行的代码
			//    });
			myChart.clear();
			myChart.setOption(option);
			let that=this;
			myChart.on('click', function(params) {
						// 高亮被点击项
						myChart.dispatchAction({
							type: 'highlight',
							seriesIndex: params.seriesIndex,
							dataIndex: params.dataIndex
						});
						
						// 显示详细tooltip
						myChart.dispatchAction({
							type: 'showTip',
							seriesIndex: params.seriesIndex,
							dataIndex: params.dataIndex
						});
						
						// 控制台输出点击数据
						// console.log('点击数据:', {
						// 	name: params.name,
						// 	value: params.value,
						// 	percent: params.percent + '%'
						// });
						const result = sj.reduce((acc, item) => {
						if (!acc[item.name]) {
							acc[item.name] = [];
						}
						acc[item.name].push(item.id);
						return acc;
						}, {});
						that.modalId=result[params.name][0];						that.title=params.name;
						that.showModal=true;
						
						
						// console.log(this.modalId);
		    });
		},
		getMyChart3s(arr) {
			HighCharts.chart("bt13", {
				chart: {
					type: "pie",
					options3d: {
						enabled: true,
						alpha: 50,
						beta: 0,
					},
					backgroundColor: null,
				},
				credits: {
					enabled: false,
				},
				title: {
					text: null,
				},
				legend: {
					enabled: false,
					itemStyle: {
						color: "#fff",
						fontSize: "10",
					},
					//        width: 100, // 设置图例宽度
					symbolHeight: 10, // 调整图例符号高度
					symbolWidth: 10, // 调整图例符号宽度
					symbolRadius: 0, // 调整图例符号圆角
					//        itemMarginTop: 10,
					align: "center", // 图例水平对齐方式（可选值：'left', 'center', 'right'）
					verticalAlign: "bottom", // 图例垂直对齐方式（可选值：'top', 'middle', 'bottom'）
					labelFormatter: function () {
						return this.name;
					}
				},
				plotOptions: {
					pie: {
						size: 180,
						showInLegend: true,
						allowPointSelect: true, //每个扇块能否选中
						depth: 30, //饼图的厚度
						borderWidth: 2,
						borderColor: '#FFFFFF', // 设置边框颜色为白色
						dataLabels: {
							distance: 20, //控制饼图外面的线的长短,为负数时文本内容在饼图内部
							enabled: false, //是否显示饼图的线形tip
						},
					},
				},
				series: [
					{
						size: 150,
						name: "教师职称分布",
						// name: "特色文化育人品牌成果",
						data:arr,
						colors: ["#517FD9", "#FE8D37", "#FFC808", "#80CB4B", "#38CEC1"],
					},
				],
			});
		},
		getMyChart3(arr) {
			HighCharts.chart("bt3", {
				chart: {
					type: "pie",
					options3d: {
						enabled: true,
						alpha: 50,
						beta: 0,
					},
					backgroundColor: null,
				},
				credits: {
					enabled: false,
				},
				title: {
					text: null,
				},
				legend: {
					enabled: false,
					itemStyle: {
						color: "#fff",
						fontSize: "10",
					},
					//        width: 100, // 设置图例宽度
					symbolHeight: 10, // 调整图例符号高度
					symbolWidth: 10, // 调整图例符号宽度
					symbolRadius: 0, // 调整图例符号圆角
					//        itemMarginTop: 10,
					align: "center", // 图例水平对齐方式（可选值：'left', 'center', 'right'）
					verticalAlign: "bottom", // 图例垂直对齐方式（可选值：'top', 'middle', 'bottom'）
					labelFormatter: function () {
						return this.name;
					}
				},
				plotOptions: {
					pie: {
						size: 180,
						showInLegend: true,
						allowPointSelect: true, //每个扇块能否选中
						depth: 30, //饼图的厚度
						borderWidth: 2,
						borderColor: '#FFFFFF', // 设置边框颜色为白色
						dataLabels: {
							distance: 20, //控制饼图外面的线的长短,为负数时文本内容在饼图内部
							enabled: false, //是否显示饼图的线形tip
						},
					},
				},
				series: [
					{
						// size: 150,
						// name: "教师职称分布",
						name: "特色文化育人品牌成果",
						data: arr,
						// data:[	["教改项目数量", 670, 16.25],
						// 	["课程申报数量", 865, 20.98],
						// 	["教学成果数量", 1125, 27.29],],
						colors: ["#517FD9", "#FE8D37", "#FFC808", "#80CB4B", "#38CEC1"],
					},
				],
			});
		},
		zzt2dd(id, value, value1) {
			var myChart = echarts.init(document.getElementById(id));
			let option = {
				grid: {
					containLabel: true,
					left: 5,
					right: 15,
					bottom: 15,
					top: 30,
				},
				legend: {
					show: false,
				},
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					}
				},
				xAxis: {
					type: 'category',
					data: value,
					axisLabel: {
						textStyle: {
							color: "#68A8CC"
						},
						formatter: function (value) {
							let rowMAx = 4
							let overValue = ''
							for (let i = 0; i < value.length; i++) {
								if ((i % rowMAx == 0) && (i != 0)) {
									overValue += '\n'
									overValue += value[i]
								} else {
									overValue += value[i]
								}
							}
							return overValue
						},
					},
					axisTick: {
						show: false,
					},
					axisLine: {
						show: true,
						lineStyle: {
							color: "#3c71c1",
						}
					},
				},
				yAxis: {
					type: 'value',
					name: '',
					nameTextStyle: {
						color: '#68A8CC',
					},
					axisLabel: {
						textStyle: {
							color: "#68A8CC"
						},
						formatter: '{value}%'
					},
					axisLine: {
						show: false,
						lineStyle: {
							color: "#68A8CC",
						}
					},
					splitLine: { // y 轴分隔线配置
						show: true, // 是否显示分隔线
						lineStyle: {
							color: '#68A8CC', // 分隔线颜色
						}
					}
				},
				series: [{
					name: '资金使用情况',
					data: value1,
					type: 'bar',
					barWidth: "15",
					barGap: '30%',
					itemStyle: {
						normal: {
							borderColor: '#0083E5', // 边框颜色
							borderWidth: 2,
							color: function (params) { // 内部颜色
								return '#0055A8';
							}
						}
					},
					showBackground: false,
					backgroundStyle: {
						color: '#04195e'
					},
					label: {
						show: true,
						position: 'top',
						color: '#fff',
						formatter: '{c}%'
					}
				},
				]
			};
			myChart.clear();
			myChart.setOption(option);
		},
		getMyChart6(value, arr, arr2) {
			console.log(arr2);
			HighCharts.chart("bt2", {
				chart: {
					type: "pie",
					options3d: {
						enabled: true,
						alpha: 60,
						beta: 0,
					},
					backgroundColor: null,
				},
				credits: {
					enabled: false,
				},
				title: {
					text: null,
				},
				legend: {
					enabled: false,
					itemStyle: {
						color: "#fff",
						fontSize: "14",
					},
					width: 100, // 设置图例宽度
					symbolHeight: 10, // 调整图例符号高度
					symbolWidth: 10, // 调整图例符号宽度
					symbolRadius: 0, // 调整图例符号圆角
					itemMarginTop: 10,
					align: "right", // 图例水平对齐方式（可选值：'left', 'center', 'right'）
					verticalAlign: "middle", // 图例垂直对齐方式（可选值：'top', 'middle', 'bottom'）
				},
				plotOptions: {
					pie: {
						size: value,
						showInLegend: true,
						allowPointSelect: true, //每个扇块能否选中
						depth: 30, //饼图的厚度
						borderWidth: 2,
						borderColor: '#FFFFFF', // 设置边框颜色为白色
						dataLabels: {
							distance: 20, //控制饼图外面的线的长短,为负数时文本内容在饼图内部
							enabled: true, //是否显示饼图的线形tip
							formatter: function (color) {
								console.log(this.point.colorIndex);
								//			              	+this.point.y+
								return '<b style="color:' + this.point.color + ';font-size:14px;">' + arr2[this.point.colorIndex] + '元</b></br>' + this.point.name;
							},
							style: {
								color: "#fff",
								textOutline: "none",
								fontSize: 14,
							},
						},
					},
				},
				series: [
					{
						// size: 150,
						name: "使用占比",
						data: arr,
						colors: ["#80CB4B", "#FFC808", "#FE8D37", "#517FD9"],
					},
				],
			});
		},
		getMyChart5(value, arr) {
			HighCharts.chart("bt", {
				chart: {
					type: "pie",
					options3d: {
						enabled: true,
						alpha: 50,
						beta: 0,
					},
					backgroundColor: null,
				},
				credits: {
					enabled: false,
				},
				title: {
					text: null,
				},
				legend: {
					enabled: true,
					itemHoverStyle: {
						color: '#02f4f5'  // 修改图例悬停时文本颜色为蓝色
					},
					itemStyle: {
						color: "#fff",
						fontSize: "10",
					},
					//        width: 100, // 设置图例宽度
					symbolHeight: 10, // 调整图例符号高度
					symbolWidth: 10, // 调整图例符号宽度
					symbolRadius: 0, // 调整图例符号圆角
					//        itemMarginTop: 10,
					align: "center", // 图例水平对齐方式（可选值：'left', 'center', 'right'）
					verticalAlign: "bottom", // 图例垂直对齐方式（可选值：'top', 'middle', 'bottom'）
					labelFormatter: function () {
						return this.name;
					}
				},
				plotOptions: {
					pie: {
						size: value,
						showInLegend: true,
						allowPointSelect: true, //每个扇块能否选中
						depth: 30, //饼图的厚度
						borderWidth: 2,
						borderColor: '#FFFFFF', // 设置边框颜色为白色
						dataLabels: {
							distance: 20, //控制饼图外面的线的长短,为负数时文本内容在饼图内部
							enabled: false, //是否显示饼图的线形tip
						},
					},
				},
				series: [
					{
						// size: 150,
						name: "品牌归属",
						data: arr,
						colors: ["#80CB4B", "#FFC808", "#FE8D37", "#517FD9", "#38CEC1"],
					},
				],
			});
		},
		getppfb(value, arr, arr1, arr2) {
			var myChart = echarts.init(document.getElementById('ppfb'));
			//			 var initialDisplayCount = 5;
			//			  // 根据初始显示数量获取 yAxis 数据
			//			 var yAxisData = arr.slice(0, initialDisplayCount);
			let option = {
				color: [
					'#007380',
					'#664A31',
					'#004997',
					'#42237B'
				],
				title: {
					text: ''
				},
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					}
				},
				legend: {
					textStyle: {
						color: '#E9EAEF' // 设置图例文本颜色
					},
				},
				grid: {
					left: '3%',
					right: value,
					bottom: '3%',
					containLabel: true
				},
				xAxis: {
					type: 'value',
					boundaryGap: [0, 0.01],
					axisLabel: {
						textStyle: {
							color: "#68A8CC"
						},
					},
					axisLine: {
						show: true,
						lineStyle: {
							color: "#68A8CC",
						}
					},
				},
				yAxis: {
					type: 'category',
					data: arr,
					axisLabel: {
						textStyle: {
							color: "#68A8CC"
						},

					},
					axisLine: {
						show: true,
						lineStyle: {
							color: "#68A8CC",
						}
					},
					splitLine: { // y 轴分隔线配置
						show: false, // 是否显示分隔线
						lineStyle: {
							color: '#68A8CC', // 分隔线颜色
						}
					},
				},
				dataZoom: [{  // 数据缩放区域
					type: 'slider',  // 滑动条类型
					yAxisIndex: 0,   // 对应 yAxis 的索引
					start: 0,         // 初始窗口范围的起始百分比
					end: 50, // 初始窗口范围的结束百分比
					showDataShadow: false, // 是否显示数据阴影
					bottom: 40,
					textStyle: {
						color: 'transparent' // 修改滑块文字颜色
					},
					zoomLock: true,
					top: 60,
					left: 0,
					width: '10px',
					height: '70%',
				}],
				series: [
					{
						name: arr2[0],
						type: 'bar',
						data: arr1[0],
						itemStyle: {
							normal: {
								borderColor: '#00FFC6', // 边框颜色
								borderWidth: 2,
								color: function (params) { // 内部颜色
									return '#007380';
								}
							}
						},
					},
					{
						name: arr2[1],
						type: 'bar',
						data: arr1[1],
						itemStyle: {
							normal: {
								borderColor: '#FF9C00', // 边框颜色
								borderWidth: 2,
								color: function (params) { // 内部颜色
									return '#664A31';
								}
							}
						},
					},
					{
						name: arr2[2],
						type: 'bar',
						data: arr1[2],
						itemStyle: {
							normal: {
								borderColor: '#009CFF', // 边框颜色
								borderWidth: 2,
								color: function (params) { // 内部颜色
									return '#004997';
								}
							}
						},
					},
					{
						name: arr2[3],
						type: 'bar',
						data: arr1[3],
						itemStyle: {
							normal: {
								borderColor: '#A63AB9', // 边框颜色
								borderWidth: 2,
								color: function (params) { // 内部颜色
									return '#42237B';
								}
							}
						},
					}
				]
			};
			myChart.clear();
			myChart.setOption(option);
		},
		mgt(arr, title, dataValue) {

			var myChart = echarts.init(document.getElementById('mg'));
			var colorList = ['#4450BB', '#5F6CE6', '#58C9F7', '#F74D4E', '#FAC231', '#38CEC1', '#FE8D37', '#38CEC1', '#80CB4B', '#517FD9', '#517FD9',];
			//					var title = ['品牌精神1','品牌精神2','品牌精神3','品牌精神4','品牌精神5'];
			//					var dataValue = ['20','20','20','20','20'];
			var dataList = title.map((item, index) => {
				return {
					name: item,
					value: dataValue[index],
					itemStyle: {
						color: colorList[index]
					},
				};
			});
			var center = ['50%', '50%'];
			var option = {
				color: colorList,
				series: [
					{
						type: 'pie',
						center: center,
						radius: arr, // 玫瑰图半径范围
						roseType: 'radius', // 玫瑰图类型
						label: {
							show: true,
							position: 'outside',
							alignTo: 'labelLine',
							//					            backgroundColor: '#fff',
							padding: [3, -3, 3, -3],
							formatter: function (params) {
								return `{a|${params.value}%}\n{b${params.dataIndex}|${params.name}}`
							},
							rich: {
								a: {
									//					                  padding: [10, 100, 10,100],
									fontSize: '14px',
									fontFamily: 'MicrosoftYaHei',
									fontWeight: 'bold',
									color: '#fff',
									lineHeight: 24,
								},
								b0: {
									color: '#4450BB',
									fontSize: '12px',
									fontFamily: 'MicrosoftYaHei',
									fontWeight: 'bold',
									lineHeight: 24,
								},
								b1: {
									color: '#5F6CE6',
									fontSize: '12px',
									fontFamily: 'MicrosoftYaHei',
									fontWeight: 'bold',
									lineHeight: 24,
								},
								b2: {
									color: '#58C9F7',
									fontSize: '12px',
									fontFamily: 'MicrosoftYaHei',
									fontWeight: 'bold',
									lineHeight: 24,
								},
								b3: {
									color: '#F74D4E',
									fontSize: '12px',
									fontFamily: 'MicrosoftYaHei',
									fontWeight: 'bold',
									lineHeight: 24,
								},
								b4: {
									color: '#FAC231',
									fontSize: '12px',
									fontFamily: 'MicrosoftYaHei',
									fontWeight: 'bold',
									lineHeight: 24,
								},
								b5: {
									color: colorList[5],
									fontSize: '12px',
									fontFamily: 'MicrosoftYaHei',
									fontWeight: 'bold',
									lineHeight: 24,
								},
								b6: {
									color: colorList[6],
									fontSize: '12px',
									fontFamily: 'MicrosoftYaHei',
									fontWeight: 'bold',
									lineHeight: 24,
								},
								b7: {
									color: colorList[7],
									fontSize: '12px',
									fontFamily: 'MicrosoftYaHei',
									fontWeight: 'bold',
									lineHeight: 24,
								},
								b8: {
									color: colorList[8],
									fontSize: '12px',
									fontFamily: 'MicrosoftYaHei',
									fontWeight: 'bold',
									lineHeight: 24,
								},
								b9: {
									color: colorList[9],
									fontSize: '12px',
									fontFamily: 'MicrosoftYaHei',
									fontWeight: 'bold',
									lineHeight: 24,
								},
								b10: {
									color: colorList[10],
									fontSize: '12px',
									fontFamily: 'MicrosoftYaHei',
									fontWeight: 'bold',
									lineHeight: 24,
								}
							}
						},
						data: dataList,
					},
				],
			}
			myChart.clear();
			myChart.setOption(option);
		},
		getszjd(id) {
			let value = ['太原', '大同', '阳泉', '长治', '晋城', '朔州', '晋中', '运城', '忻州', '临汾', '吕梁'];
			let value1 = [15, 10, 8, 8, 8, 9, 9, 8, 9, 7, 9];
			var myChart = echarts.init(document.getElementById(id));
			let option = {
				grid: {
					containLabel: true,
					left: 5,
					right: 15,
					bottom: 15,
					top: 30,
				},
				legend: {
					show: false,
				},
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					}
				},
				xAxis: {
					type: 'category',
					data: value,
					axisLabel: {
						textStyle: {
							color: "#68A8CC"
						},
						formatter: function (value) {
							let rowMAx = 4
							let overValue = ''
							for (let i = 0; i < value.length; i++) {
								if ((i % rowMAx == 0) && (i != 0)) {
									overValue += '\n'
									overValue += value[i]
								} else {
									overValue += value[i]
								}
							}
							return overValue
						},
					},
					axisTick: {
						show: false,
					},
					axisLine: {
						show: true,
						lineStyle: {
							color: "#3c71c1",
						}
					},
				},
				yAxis: {
					type: 'value',
					name: '',
					nameTextStyle: {
						color: '#68A8CC',
					},
					axisLabel: {
						textStyle: {
							color: "#68A8CC"
						},
						formatter: '{value}'
					},
					axisLine: {
						show: false,
						lineStyle: {
							color: "#68A8CC",
						}
					},
					splitLine: { // y 轴分隔线配置
						show: true, // 是否显示分隔线
						lineStyle: {
							color: '#68A8CC', // 分隔线颜色
						}
					}
				},
				series: [{
					name: '思政实践基地个数',
					data: value1,
					type: 'bar',
					barWidth: "15",
					barGap: '30%',
					itemStyle: {
						normal: {
							borderColor: '#0083E5', // 边框颜色
							borderWidth: 2,
							color: function (params) { // 内部颜色
								return '#0055A8';
							}
						}
					},
					showBackground: false,
					backgroundStyle: {
						color: '#04195e'
					},
					label: {
						show: true,
						position: 'top',
						color: '#fff',
						formatter: '{c}'
					}
				},
				]
			};
			myChart.clear();
			myChart.setOption(option);
		},
	}
}
</script>

<style lang="scss" scoped>
p {
	margin: 0px;
	padding: 0px;
}

.flex {
	display: flex;
}

.spa-bet {
	justify-content: space-between;
}

.ztbox {
	width: 100%;
	height: auto;
	/*background: url("../../assets/images/bigdatas/banner.png") no-repeat;*/
	/*background-repeat: no-repeat;*/
	/*background-size: 100% 100%;*/
	/*padding:0px 20px 20px;*/
	box-sizing: border-box;
	/*max-width:1366px;*/
	flex: 1;

	/*.ztheader{
  	 height:80px;
  	 margin-bottom:10px;
  }*/
	.ztcenter {
		width: 100%;

		.centerone {
			width: 100%;
			height: 48px;
			background: url("../../assets/images/xin/ts1.png") no-repeat;
			background-repeat: no-repeat;
			background-size: 100% 100%;
			padding-left: 30px;
			line-height: 48px;
			font-weight: bold;
			font-size: 20px;
			color: #02F4F5;
		}

		.centertwo {
			width: 100%;
			height: 128px;
			background: url("../../assets/images/xin/ts2.png") no-repeat;
			background-repeat: no-repeat;
			background-size: 100% 100%;
			padding: 10px;
			box-sizing: border-box;

			.twoleft {
				/*max-width:496px;*/
				width: 25%;
				height: 108px;
				background: url("../../assets/images/xin/t10.png") no-repeat;
				background-repeat: no-repeat;
				background-size: 100% 100%;
				padding: 20px 0px;
				box-sizing: border-box;
				display: flex;
				justify-content: flex-start;
				align-items: center;

				.leftbox {
					height: 68px;
					width: 24%;
				}

				.leftimg {
					width: 1px;
					height: 68px;
				}

				.lefttext {
					font-size: 16px;
					text-align: center;
					color: #fff;
					line-height: 34px;
				}

				.leftspan {
					color: #FFD70E;
					font-size: 20px;
				}

				.lefttext1 {
					font-size: 12px;
					text-align: center;
					color: #fff;
					line-height: 34px;
				}
			}

			.tworight {
				width: 74%;
				display: flex;
				justify-content: space-around;
				align-items: center;

				.rightitem {
					width: calc((100% - 30px)/4);
					height: 108px;
					background: url("../../assets/images/xin/t12.png") no-repeat;
					background-repeat: no-repeat;
					background-size: 100% 100%;
					padding: 20px 10px;
					box-sizing: border-box;
					display: flex;
					justify-content: flex-start;
					align-items: center;

					.rightimg {
						width: 45px;
						height: 45px;
						margin-right: 5px;
					}

					.righttext {
						font-size: 16px;
						text-align: center;
						color: #fff;
						width: 120px;
					}

					.rightlist {
						width: 60%;
						height: 88px;

						.listtext {
							font-size: 16px;
							line-height: 29px;
							color: #fff;
							white-space: nowrap;
							/* 不换行 */
							overflow: hidden;
							/* 隐藏超出部分 */
							text-overflow: ellipsis;
							/* 超出部分用省略号表示 */
						}

						.listspan {
							color: #7CFFFD;
						}
					}
				}
			}
		}

		.centerthree {
			margin-top: 20px;

			.threelist {
				margin-bottom: 10px;

				.listitem {
					width: calc((100% - 30px)/4);

					.listtitle {
						width: 100%;
						height: 48px;
						background: url("../../assets/images/xin/t21.png") no-repeat;
						background-repeat: no-repeat;
						background-size: 100% 100%;
						padding-left: 30px;
						line-height: 48px;
						font-weight: bold;
						font-size: 20px;
						color: #02F4F5;
						position: relative;
						display: flex;

						.titletext {
							height: 48px;
							position: absolute;
							top: 0px;
							right: 10px;
							font-size: 16px;
							line-height: 48px;
							color: #fff;

						}

						.titlespan {
							color: #F9D314;
						}
					}

					.listbg {
						width: 100%;
						height: 320px;
						background: url("../../assets/images/xin/t20.png") no-repeat;
						background-repeat: no-repeat;
						background-size: 100% 100%;
						padding: 10px;
						box-sizing: border-box;
						overflow: hidden;

						table {
							width: 100% !important;
						}

						.listone {
							width: 100%;
							height: 26px;
							background: url("../../assets/images/xin/t23.png") no-repeat;
							background-repeat: no-repeat;
							background-size: 100% 100%;
							text-align: center;
							line-height: 26px;
							font-size: 16px;
							color: #fff;

							.listonespan {
								color: #FFD70E;
								font-weight: bold;
							}
						}

						.bglist {
							min-height: 32px;
							/*margin-bottom:10px;*/
							display: flex;
							justify-content: space-between;
							align-items: center;
							flex-wrap: wrap;

							.bgitem {
								width: calc((100% - 10px)/2);
								height: 32px;
								display: flex;
								justify-content: space-between;
								align-items: center;
								background: url("../../assets/images/xin/t22.png") no-repeat;
								background-repeat: no-repeat;
								background-size: 100% 100%;
								padding: 0px 10px;
								margin-bottom: 10px;
								box-sizing: border-box;
							}

							.bgi1 {
								font-size: 16px;
								color: #fff;
							}

							.bgi2 {
								font-size: 16px;
								color: #FFD70E;
								font-weight: bold;
							}
						}
					}

					.btlist {
						width: 100%;
						padding: 0px 10px;
						display: flex;
						justify-content: space-between;
						flex-wrap: wrap;

						.btitem {
							width: calc((100% - 10px)/2);
							height: 28px;
							padding: 0px 10px;
							box-sizing: border-box;
							display: flex;
							justify-content: space-between;
							align-items: center;
							background: url("../../assets/images/xin/t31.png") no-repeat;
							background-repeat: no-repeat;
							background-size: 100% 100%;

							.btitemspan {
								color: #fff;
								font-size: 14px;
							}

							.btitemspan1 {
								color: #517FD9;
								;
								font-size: 14px;
							}

						}

						.btitem3 {
							background: url("../../assets/images/xin/t32.png") no-repeat;

							.btitemspan1 {
								color: #80CB4B;
								font-size: 14px;
							}
						}

						.btitem4 {
							background: url("../../assets/images/xin/t33.png") no-repeat;

							.btitemspan1 {
								color: #FE8D37;
								font-size: 14px;
							}
						}

						.btitem1 {
							background: url("../../assets/images/xin/t34.png") no-repeat;

							.btitemspan1 {
								/*color:#80CB4B;*/
								color: #FE8D37;
								font-size: 14px;
							}
						}

						.btitem2 {
							background: url("../../assets/images/xin/t35.png") no-repeat;

							.btitemspan1 {
								color: #FFC808;
								font-size: 14px;
							}
						}
					}
				}

			}
		}
	}

	.tables {
		width: 100%;

		thead {
			tr {
				background-color: #08276F;
				height: 48px;

				th {
					width: 50%;
					height: 48px;
					/*display: inline-block;*/
					line-height: 48px;
					text-align: center;
					font-size: 16px;
					color: #8298FB;
				}
			}
		}

		tbody {
			tr {
				height: 46px;
				border-bottom: 1px dotted #5E6C92;

				td {
					width: 50%;
					height: 46px;
					line-height: 46px;
					text-align: center;
					font-size: 16px;
					color: #fff;
					/*display: inline-block;*/
					white-space: nowrap;
					/* 不换行 */
					overflow: hidden;
					/* 隐藏超出部分 */
					text-overflow: ellipsis;
				}
			}
		}
	}
}

@media screen and (max-width: 1440px) and (min-width: 1367px) {

	.leftspan,
	.centerone {
		font-size: 18px !important;
	}

	.listtitle {
		font-size: 18px !important;
	}

	.lefttext,
	.titletext,
	.listone {
		font-size: 14px !important;
	}

	.rightimg {
		width: 35px !important;
		height: 35px !important;
	}

	.righttext {
		font-size: 14px !important;
	}

	.listtext,
	.bgi1,
	.bgi2 {
		font-size: 14px !important;
	}

	.tables {
		width: 100%;

		thead {
			tr {
				background-color: #08276F;
				height: 48px;

				th {
					width: 50%;
					height: 48px;
					line-height: 48px;
					text-align: center;
					font-size: 14px !important;
					color: #8298FB;
				}
			}
		}

		tbody {
			tr {
				height: 46px;
				border-bottom: 1px dotted #5E6C92;

				td {
					width: 50%;
					height: 46px;
					line-height: 46px;
					text-align: center;
					font-size: 14px !important;
					color: #fff;
					white-space: nowrap;
					/* 不换行 */
					overflow: hidden;
					/* 隐藏超出部分 */
					text-overflow: ellipsis;
				}
			}
		}
	}
}

@media screen and (max-width: 1366px) {

	.leftspan,
	.centerone {
		font-size: 16px !important;
	}

	.lefttext,
	.titletext,
	.listone {
		font-size: 14px !important;
	}

	.rightimg {
		width: 35px !important;
		height: 35px !important;
	}

	.righttext {
		font-size: 12px !important;
		width: 80px !important;
	}

	.listtext,
	.bgi1,
	.bgi2 {
		font-size: 12px !important;
	}

	.listtitle {
		font-size: 16px !important;
	}

	.tables {
		width: 100%;

		thead {
			tr {
				background-color: #08276F;
				height: 48px;

				th {
					width: 50%;
					height: 48px;
					line-height: 48px;
					text-align: center;
					font-size: 14px !important;
					color: #8298FB;
				}
			}
		}

		tbody {
			tr {
				height: 46px;
				border-bottom: 1px dotted #5E6C92;

				td {
					width: 50%;
					height: 46px;
					line-height: 46px;
					text-align: center;
					font-size: 14px !important;
					color: #fff;
					white-space: nowrap;
					/* 不换行 */
					overflow: hidden;
					/* 隐藏超出部分 */
					text-overflow: ellipsis;
				}
			}
		}
	}
}

::v-deep .ant-select-selection {
	background-color: #01297d;
	color: #fff;
	border-color: #2669e6;
}

::v-deep .ant-select-dropdown {
	background-color: #01297d;
	color: #fff;
}

::v-deep .ant-select-arrow {
	background-color: #01297d;
	color: #fff;
}

::v-deep .ant-radio-button-wrapper {
	color: #999;
	background-color: #0d308d;
	border-color: #ffffff00;
	border-radius: 0;
}

::-webkit-scrollbar {
	width: 4px;
	/* 滚动条宽度 */
}

::-webkit-scrollbar-track {
	background: #01389c;
	/* 滚动条轨道背景色 */
	border-radius: 10px;
	/* 可选：轨道圆角 */
}

::-webkit-scrollbar-thumb {
	background: #a0d1f4;
	/* 滚动条颜色 */
	border-radius: 10px;
	/* 可选：滚动条圆角 */
}

::-webkit-scrollbar-thumb:hover {
	background: #01389c;
	/* 鼠标悬停时滚动条颜色 */
}
</style>

<style lang="scss">
.customClass {
	background: #01297d;

	.ant-select-dropdown-menu-item {
		background-color: #01297d;
		color: #fff;

		&:not(:last-child) {
			border-bottom: 1px solid #999;
		}

		&:hover:not(.ant-select-dropdown-menu-item-disabled) {
			background-color: #0f5bff;
		}
	}
}
</style>